import RestfulService from "../common/RestfulService";

const templatePackageService = new RestfulService("/issb/template-package");

export default templatePackageService;
